import { keys } from "lodash";
import { FILE_TYPE } from "consts";

export const getSelectedOptions = (response, question) => {
  const selectedQuestion = response.questions[question.virtual_id] || {};
  const ids = keys(selectedQuestion.options)
    .map(id => parseInt(id, 10))
    .filter(id => id || id === 0);
  return ids.map(id => question.options.find(o => o.virtual_id === id));
};

export const getSelectedSubOptions = (selectedOptions, option) => {
  const selectedOption = selectedOptions[option.virtual_id] || {};
  const ids = keys(selectedOption.subOptions).map(id => parseInt(id, 10));
  return ids.map(id => option.options.find(o => o.virtual_id === id));
};

export const getAddedFiles = selectedOption => {
  const files = selectedOption.files || [];

  const mediaFiles = files.filter(
    file => file.type === FILE_TYPE.IMAGE || file.type === FILE_TYPE.VIDEO,
  );

  const audioFiles = files.filter(file => file.type === FILE_TYPE.AUDIO);
  const audioFile = audioFiles.length ? audioFiles[0] : {};

  return { mediaFiles, audioFile };
};

export const getQuizScore = state => {
  const { sectionStack } = state.navigation;
  let total = 0;
  let score = 0;

  for (const section of sectionStack) {
    for (const question of section.questions) {
      total += 1;
      const questionResponse = state.response.questions[question.virtual_id];
      if (!questionResponse) {
        continue;
      }

      let qTotal = 0;
      let qScore = 0;
      for (const option of question.options) {
        const selectedOption = questionResponse.options[option.virtual_id];
        if (option.is_correct || option.correct_answer) {
          qTotal += 1;
          if (selectedOption && !option.correct_answer) {
            qScore += 1;
          }
        }
        if (option.correct_answer) {
          if (selectedOption.other_text === option.correct_answer) {
            qScore += 1;
          }
        }
      }

      if (qTotal !== 0) {
        score += qScore / qTotal;
      }
    }
  }

  return [total, score];
};
